import { v4 as uuidv4 } from "uuid";
export const blogsArray = [
  {
    id: uuidv4(),
    name: "",
    date: "",
    content: "all",
    category: "all",
    author: "all",
    images: [
      {
        id: uuidv4(),
        image: "",
      },
    ],
  },
  {
    id: uuidv4(),
    name: "Books",
    date: "2020-05-29",
    content:
      "A book is a medium for recording information in the form of writing or images, typically composed of many pages (made of papyrus, parchment, vellum, or paper) bound together and protected by a cover.[1] The technical term for this physical arrangement is codex (plural, codices). In the history of hand-held physical supports for extended written compositions or records, the codex replaces its immediate predecessor, the scroll. A single sheet in a codex is a leaf, and each side of a leaf is a page.",
    category: "books",
    author: "gjoko",
    images: [
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/lUaaKCUANVI/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/HH4WBGNyltc/200x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/YLSwjSy7stw/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/2JIvboGLeho/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/Oaqk7qqNh_c/500x300",
      },
    ],
  },
  {
    id: uuidv4(),
    name: "Cafes",
    date: "2020-05-29",
    content:
      "Café redirects here. While café may refer to a coffeehouse, the term café generally refers to a casual eating place, such as a Diner, British café,A coffeehouse, coffee shop, or café is an establishment that primarily serves coffee (of various types, e.g. espresso, latte, cappuccino).",
    category: "cafes",
    author: "gjoko",
    images: [
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/qE1jxYXiwOA/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/VobvKmG-StA/270x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/OXXsAafHDeo/500x300",
      },
    ],
  },
  {
    id: uuidv4(),
    name: "Exhibition",
    date: "2020-05-29",
    content:
      "An exhibition, in the most general sense, is an organized presentation and display of a selection of items. In practice, exhibitions usually occur within a cultural or educational setting such as a museum, art gallery, park, library, exhibition hall, or World's fairs.",
    category: "exhibition",
    author: "bulovski",
    images: [
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/QbX8A8eHfzw/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/lq-3u9EqNb4/500x300",
      },
    ],
  },
  {
    id: uuidv4(),
    name: "Food",
    date: "2020-05-29",
    content:
      "Food is any substance[1] consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals. The substance is ingested by an organism and assimilated by the organism's cells to provide energy, maintain life, or stimulate growth.",
    category: "food",
    author: "bulovski",
    images: [
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/4_jhDO54BYg/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/MNtag_eXMKw/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/-YHSwy6uqvk/500x300",
      },
    ],
  },
  {
    id: uuidv4(),
    name: "Cafes Ohrid",
    date: "2020-05-29",
    content:
      "A coffeehouse, coffee shop, or café is an establishment that primarily serves coffee (of various types, e.g. espresso, latte, cappuccino). Some coffeehouses may serve cold drinks such as iced coffee and iced tea; in continental Europe, cafés serve alcoholic drinks. A coffeehouse may also serve food such as light snacks, sandwiches, muffins or pastries.",
    category: "cafes",
    author: "gjoko",
    images: [
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/GXXYkSwndP4/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/OXXsAafHDeo/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/qE1jxYXiwOA/500x300",
      },
    ],
  },
  {
    id: uuidv4(),
    name: "Food raspberry",
    date: "2020-05-29",
    content:
      "The raspberry is the edible fruit of a multitude of plant species in the genus Rubus of the rose family, most of which are in the subgenus Idaeobatus; the name also applies to these plants themselves. Raspberries are perennial with woody stems.",
    category: "food",
    author: "bulovski",
    images: [
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/napjvLy6lys/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/mnu0ErKoA3s/500x300",
      },
      {
        id: uuidv4(),
        image: "https://source.unsplash.com/CfsFfbdRK70/500x300",
      },
    ],
  },
];
